import React from 'react';
import PropTypes from 'prop-types';
import { iconsList } from '../icon/glyphs';
import BaseActionListItem from './index';
import FileTrigger from './file-trigger';

const ActionListFileTrigger = ({
  fileTriggerConfig,
  iconGlyph = null,
  disabled = false,
  selected = false,
  onClick = Function.prototype,
  ...otherProps
}) => {
  const File = ({ children }) => (
    <React.Fragment>
      {children}
      <FileTrigger {...fileTriggerConfig} />
    </React.Fragment>
  );

  return (
    <BaseActionListItem
      iconGlyph={iconGlyph}
      disabled={disabled}
      selected={selected}
      onClick={onClick}
      component={File}
      {...otherProps}
    />
  );
};

ActionListFileTrigger.propTypes = {
  title: PropTypes.string.isRequired,
  iconGlyph: PropTypes.oneOf(iconsList),
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  fileTriggerConfig: PropTypes.shape().isRequired,
  children: PropTypes.node,
};

export default ActionListFileTrigger;
